// 按需加载element 样式
import Vue from 'vue'
import {
    Dialog,
    Input,
    Button,
    Loading,
    Message,
    Tabs,
    TabPane,
    Select,
    Option,
    MessageBox,
    Tooltip,
    DatePicker,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Form,
    FormItem,
    Radio,
    RadioGroup,
    RadioButton,
    Popover,
    Checkbox,
    CheckboxGroup,
    Carousel,
    CarouselItem,
    Card,
    Collapse,
    CollapseItem,
    Timeline,
    TimelineItem,
    Tree,
    TableColumn,
    Table,
    Pagination
} from 'element-ui';
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Button);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio)
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Card);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Tree);
Vue.use(TableColumn);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;